import { Injectable } from '@angular/core';
import { Mutation, gql } from 'apollo-angular';

import { StorefrontBasic, StorefrontBasicFragment } from './storefront-basic.fragment';
import { PaymentMethodType } from '@app/shared/models/enums/payment-method-types';

@Injectable({
  providedIn: 'root'
})
export class CreateStorefrontGQL extends Mutation<CreateStorefrontGQLResponse, CreateStorefrontGQLVariables> {
  document = gql`
    mutation createStorefront($data: CreateStorefrontInput!) {
      createStorefront(data: $data) {
        ...StorefrontBasic
      }
    }
    ${StorefrontBasicFragment}
  `;
}

interface CreateStorefrontGQLVariables {
  data: CreateStorefrontInput;
}

interface CreateStorefrontGQLResponse {
  createStorefront: StorefrontBasic;
}

export interface CreateStorefrontInput {
  name: string;
  catalogId: string;
  partnerId: number;
  allowedPaymentMethods?: {
    isCustomerDefault: boolean;
    paymentMethodType: PaymentMethodType
  }[];
}
